import Constants from "expo-constants";
import type { ClientApp } from "@repo/graphql/client";

export const APP_LABEL = "montu";

export {
  INSTAGRAM_CLIENT_ID,
  TIKTOK_CLIENT_ID,
} from "@repo/components/src/constants/socialClientIds";
export const INSTAGRAM_REDIRECT_URI = `https://center.montu.io/app/auth/instagram`;
export const TIKTOK_REDIRECT_URI = `https://center.montu.io/app/auth/tiktok`;
export const MP_TOKEN = Constants.expoConfig?.extra?.mpToken as string;
export const HOTJAR = Constants.expoConfig?.extra?.hotjar as boolean;
export const RECCOMMENDATIONS_CARD = Constants.expoConfig?.extra
  ?.reccomendationsCard as boolean;

// Sent as `X-Client-App`, so the backend knows which app links must open.
export const CLIENT_APP: ClientApp = "center";
